// extracted by mini-css-extract-plugin
export default {"container":"Time_container__MCfDO","timeContainer":"Time_timeContainer__ZMzlv","error":"Time_error__HYpNO"};